module.exports = __webpack_public_path__ + "static/pic1-1ae4ceb839ba8e7c264d8cb593e1ead9.jpg";